import React, { useEffect } from 'react';
import styles from './Votes.module.scss'
import { useQuery } from 'react-query';
import { getClubElections } from '../../../service/election';
import { useUserStore } from '../../../store/useUser';
import Filter, { FilterItem } from '../../../components/Filter/CustomFilter';
import useSearchParam from '../../../hooks/useQueryParams';
import { getClubIdByPathname, getClubNameByPathname, getFormattedClubName, navigateToClub } from '../../../utils/club';
import FloatButton from '../../../components/FloatButton/FloatButton';
import { Election } from '../../common/Election/Election';
import { Spin } from 'antd';

import { NavLink, useParams } from 'react-router-dom';
import useHeader from '../../../hooks/useHeader';

const ClubElections: React.FC = () => {
  const { id, name: clubName } = useParams();

  const userId = useUserStore((state) => state.id);
  const profile = useUserStore(state => state.profile)
  const userIsAdmin = useUserStore(state => state.userIsAdmin)
  const userIsMediator = useUserStore(state => state.userIsMediator)
 
  const [searchType, setSearchType] = useSearchParam<string, 'book'| 'meet' | ''>('type')
  const [time, setTime] = useSearchParam<string, 'today' | 'open' | 'closed' | undefined>('time')
  
  const clubId = Number(id);

  const isAdmin = userIsAdmin(clubId)
  const isMediator = userIsMediator(clubId)

  if(searchType == null) setSearchType('')
  
  const {data, isFetching} = useQuery(
    ['election', clubId, searchType, time],
    () => getClubElections(clubId, searchType, time),
    {refetchOnMount: 'always', staleTime: 0, refetchOnWindowFocus: false},
  );

  useHeader({ header: clubName, subheader: 'Eleições' });

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.badge}/>
        <div>Votações</div>
      </div>
      <Filter>
          <FilterItem 
            active={searchType === ''}
            onClick={e => setSearchType('')}> 
              Todos
          </FilterItem>
          <FilterItem 
            onClick={e => setSearchType('meet')} 
            active={searchType === 'meet'}>
              Encontros
          </FilterItem>
          <FilterItem 
            onClick={e => setSearchType('book')} 
            active={searchType === 'book'}>
              Livros
          </FilterItem>
          <FilterItem 
            active={time === 'closed'}
            onClick={e => setTime('closed')}> 
              Finalizada
          </FilterItem>
          <FilterItem 
            onClick={e => setTime('open')} 
            active={time === 'open'}>
              Aberta
          </FilterItem>
          <FilterItem 
            onClick={e => setTime('today')} 
            active={time === 'today'}>
              Hoje
          </FilterItem>
        </Filter>
        <div className={styles.containerVotes}>
          <Spin spinning={isFetching}>
          {
            data?.map((data) => 
              <Election
                key={data?.id}
                election={data}/>
              )
          }
          </Spin>
        </div>
        { (profile !== 'Clubista' && (isAdmin || isMediator)) ? 
        <NavLink to={navigateToClub(clubName,clubId, '/vote/add')}>        
          <FloatButton>
            +
          </FloatButton>
        </NavLink>
        : null
      }
    </div>
  )
}

export default ClubElections;